import {
    useMemo,
} from 'react'
import SkyNetDataGrid from 'app/PoC/DataGridDemoPages/components/SkyNetDataGrid'
import useDataGridSource from 'app/PoC/DataGridDemoPages/components/hooks/useDataGridSource'
import {
    DataGridSupportedFeatures,
} from 'app/PoC/DataGridDemoPages/components/SkyNetMasterDataGrid/SkyNetMasterDataGrid.types'
import AdditionalFeesRequests from 'app/requests/ContractBasis/ContractBasis.requests'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    ContractBasis,
} from 'app/Apps/Pricing/Pricing.types'

import columns from './ContractBasisDemoAdditionalFees.columns'

const toolbarControls = [DataGridSupportedFeatures.ShowArchived]

const ContractBasisDemoAdditionalFees = ({
    data,
}: Readonly<{
    data: ContractBasis,
    onSuccess?: () => void,
    onCancel?: () => void,
    backPath?: string,
}>) => {
    const request = useMemo(() => {
        return AdditionalFeesRequests.filterRequestAdditionalFees({
            contractId: data.id,
            params: {},
        })
    }, [data.id])

    const dataSource = useDataGridSource({
        request,
        key: 'contractBasisDemoAdditionalFeesRequest' as RequestKeys,
    })

    return (
        <SkyNetDataGrid
            persistentKey="contract-basis-additional-fees-demo-table"
            columns={columns}
            customDataSource={dataSource}
            toolbarProps={{
                title: 'Additional Fees',
                toolbarControls: [],
            }}
            featuresLists={toolbarControls}
        />
    )
}

export default ContractBasisDemoAdditionalFees
